// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a21b3308","123":"88df7475","214":"36674153","261":"f896273b","441":"52a3dd6c","449":"a744137e","457":"5cfd3ced","534":"04e24b26","571":"a1c9a93c","581":"42cb1a93","625":"348299d1","653":"2f359848","728":"fbfe1ec5","841":"064c91a2"}[chunkId] + ".chunk.js";
};